var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkillet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_130_116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 76
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.706055,
    y: 0.365967,
    width: 75,
    height: 75,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_130_116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5342 31.616C15.2633 29.741 15.3805 28.0743 14.8857 26.616C14.391 25.1576 13.5446 23.6993 12.3467 22.241C10.6279 20.1576 9.49512 18.1915 8.94824 16.3425C8.40137 14.4936 8.31022 12.2931 8.6748 9.74097H14.7686C14.3519 11.7201 14.2868 13.3347 14.5732 14.5847C14.8597 15.8347 15.6019 17.1889 16.7998 18.6472C18.779 21.0431 20.042 23.1654 20.5889 25.0144C21.1357 26.8634 21.1488 29.0639 20.6279 31.616H14.5342ZM27.0342 31.616C27.7633 29.741 27.8936 28.0743 27.4248 26.616C26.9561 25.1576 26.1227 23.6993 24.9248 22.241C23.2061 20.1576 22.0602 18.1915 21.4873 16.3425C20.9144 14.4936 20.8102 12.2931 21.1748 9.74097H27.2686C26.8519 11.7201 26.7868 13.3347 27.0732 14.5847C27.3597 15.8347 28.1019 17.1889 29.2998 18.6472C31.279 21.0431 32.542 23.1654 33.0889 25.0144C33.6357 26.8634 33.6488 29.0639 33.1279 31.616H27.0342ZM39.5342 31.616C40.2633 29.741 40.3936 28.0743 39.9248 26.616C39.4561 25.1576 38.6227 23.6993 37.4248 22.241C35.7061 20.1576 34.5602 18.1915 33.9873 16.3425C33.4144 14.4936 33.3102 12.2931 33.6748 9.74097H39.7686C39.3519 11.7201 39.2868 13.3347 39.5732 14.5847C39.8597 15.8347 40.6019 17.1889 41.7998 18.6472C43.779 21.0431 45.042 23.1654 45.5889 25.0144C46.1357 26.8634 46.1488 29.0639 45.6279 31.616H39.5342ZM16.3311 62.866C13.7269 62.866 11.5133 61.9545 9.69043 60.1316C7.86751 58.3087 6.95605 56.0951 6.95605 53.491V37.866H50.7842C51.0446 36.0951 51.7477 34.5457 52.8936 33.2175C54.0394 31.8894 55.4456 30.9389 57.1123 30.366L71.5654 25.5222L73.5186 31.4597L59.0654 36.3035C58.4404 36.5118 57.9326 36.8894 57.542 37.4363C57.1514 37.9832 56.9561 38.5951 56.9561 39.2722V53.491C56.9561 56.0951 56.0446 58.3087 54.2217 60.1316C52.3988 61.9545 50.1852 62.866 47.5811 62.866H16.3311ZM16.3311 56.616H47.5811C48.4665 56.616 49.2087 56.3165 49.8076 55.7175C50.4066 55.1186 50.7061 54.3764 50.7061 53.491V44.116H13.2061V53.491C13.2061 54.3764 13.5055 55.1186 14.1045 55.7175C14.7035 56.3165 15.4456 56.616 16.3311 56.616Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillet);
export default __webpack_public_path__ + "static/media/skillet.8a679f7db038607f7ced39ea77e74f9d.svg";
export { ForwardRef as ReactComponent };